import type { HuntInvitation } from '../../api';

export function directionsUrl(lat?: number | null, lng?: number | null, place?: string | null): string | null {
  if (lat != null && lng != null) return `https://www.google.com/maps/dir/?api=1&destination=${lat.toFixed(6)},${lng.toFixed(6)}`;
  if (place) return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(place)}`;
  return null;
}

const utc = (iso: string) => new Date(iso).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
const esc = (s: string) => s.replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n');

/** Kalenderfil för "Lägg i kalendern" (samma UID som i mejlet, så posten ersätts vid ändring). */
export function buildIcs(inv: HuntInvitation, origin: string, now = new Date()): string {
  const ev = inv.event;
  const start = ev.meetingTime || ev.startTime;
  const end = ev.endTime || new Date(new Date(ev.startTime).getTime() + 8 * 3600_000).toISOString();
  const url = inv.token ? `${origin}/inbjudan/${inv.token}` : origin;
  const lines = [
    'BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Qvenari//Jakt//SV', 'BEGIN:VEVENT',
    `UID:${ev.id}@qvenari.com`, `SEQUENCE:${ev.revision ?? 1}`, `DTSTAMP:${utc(now.toISOString())}`,
    `DTSTART:${utc(start)}`, `DTEND:${utc(end)}`, `SUMMARY:${esc(`${ev.title} (${inv.mark.name})`)}`,
    ...(ev.meetingPlace ? [`LOCATION:${esc(ev.meetingPlace)}`] : []),
    `DESCRIPTION:${esc([inv.passLabel ? `Ditt pass: ${inv.passLabel}` : '', ev.message ?? '', url].filter(Boolean).join('\n\n'))}`,
    `URL:${url}`, 'END:VEVENT', 'END:VCALENDAR',
  ];
  return lines.join('\r\n') + '\r\n';
}
